import { Checkbox, FormControlLabel, FormGroup, Grid } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

export const SingleCheckbox = ({ label, checked, onChange, sm, xs, md, disabled }) => {
  return (
    <FormGroup>
      <Grid container spacing={3} pb={3}>
        <Grid item xs={xs ?? 12} sm={sm ?? 6} md={md ?? 4}>
          <FormControlLabel
            control={<Checkbox checked={checked} onChange={onChange} disabled={disabled} />}
            label={label}
            sx={{
              display: "flex",
              alignItems: "center",

              "& .MuiFormControlLabel-label": {
                whiteSpace: "nowrap",
                fontSize: "14px",
              },
            }}
          />
        </Grid>
      </Grid>
    </FormGroup>
  );
};

SingleCheckbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  sm: PropTypes.number,
  xs: PropTypes.number,
  md: PropTypes.number,
  disabled: PropTypes.bool,
};

export default SingleCheckbox;
